import type { ReactNode } from 'react';

export const symbol_heart_minus: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M630-410q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H630Zm-197-80ZM40-625q0-90 60.5-152.5T250-840q57 0 105.5 26.5T440-736q42-54 89-79t100.82-25q94.18 0 152.68 65.5T840-620q0 13-1.5 25t-4.5 25q-3 14-14 19t-22 2.5q-11-2.5-18.5-12T775-586q2-10 3-20.03 1-10.03 1-20.97 0-61-43-107t-106-46q-53 0-95 31t-67 79q-5 8-12.68 13T439-652q-9 0-16-5t-12-13q-25-48-66.5-79t-94.65-31Q184-780 142-735.5T100-625q0 39 15.5 76t53.89 84.07q38.39 47.06 104.5 110Q340-292 440-200l97-85q8-8 19.93-7.28 11.92.72 20.12 8.64Q586-275 586-262t-10 21l-95 84q-9 8-19.75 11.5t-21.5 3.5q-10.75 0-21.16-3.81T400-158q-44-41-105.5-94t-118-113.5Q120-426 80-492.5T40-625Z"
		/>
	</svg>
);
